import { action, observable, makeAutoObservable } from 'mobx';

export class NotificationsStateNew {
    @observable public isOpen: boolean = false;

    public constructor() {
        makeAutoObservable(this);
    }

    @action public toggleOpen = (): void => {
        this.isOpen = !this.isOpen;
    };
}
